import { render, staticRenderFns } from "./BaseDeleteConfirmModal.vue?vue&type=template&id=8efb0e40"
import script from "./BaseDeleteConfirmModal.vue?vue&type=script&lang=js"
export * from "./BaseDeleteConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8efb0e40')) {
      api.createRecord('8efb0e40', component.options)
    } else {
      api.reload('8efb0e40', component.options)
    }
    module.hot.accept("./BaseDeleteConfirmModal.vue?vue&type=template&id=8efb0e40", function () {
      api.rerender('8efb0e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BaseModal/BaseDeleteConfirmModal.vue"
export default component.exports